import { Row } from "@components/Layout";
import type { JSX } from "solid-js";
import { styled } from "solid-styled-components";

export const DataBadgeWrapper = styled(Row)<{ fontSize?: JSX.CSSProperties["font-size"] }>`
  border-radius: 15px;
  font-size: ${({ fontSize }) => fontSize ?? "12px"};
  white-space: nowrap;
  ${({ theme }) => `background: ${theme?.tracklist.dataBadge};color: ${theme?.colors.accentTertiary};`};
  @media only screen and (max-width: 1024px) {
    height: 25px;
    font-size: 10px;
  }
`;
